import React from 'react';

interface SupporterBadgeProps {
  className?: string;
}

/**
 * Cosmetic "Supporter" badge for users who support the project. Status only —
 * no feature gates. (#666)
 */
const SupporterBadge: React.FC<SupporterBadgeProps> = ({ className = '' }) => (
  <span
    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800 ${className}`}
    title="Supporter — thank you for supporting Connect Share"
  >
    <span aria-hidden="true" className="mr-1">
      🎖️
    </span>
    Supporter
  </span>
);

export default SupporterBadge;
